export default __webpack_public_path__ + "static/1204-7a60ba0ec33b755140efa70777133aa4.gif";